import React from 'react';
import { IconProps } from '../types';
const MinecraftSoulCampfire: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="1" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(8, 143, 146, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(37, 198, 205, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(37, 198, 205, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(8, 143, 146, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(91, 227, 232, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(37, 198, 205, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(37, 198, 205, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(8, 143, 146, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(37, 198, 205, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(91, 227, 232, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(91, 227, 232, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(37, 198, 205, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(8, 143, 146, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(91, 227, 232, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(124, 242, 245, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(124, 242, 245, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(91, 227, 232, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(8, 143, 146, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(91, 227, 232, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(124, 242, 245, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(124, 242, 245, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(212, 254, 255, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(124, 242, 245, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(91, 227, 232, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(8, 143, 146, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(37, 198, 205, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(91, 227, 232, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(212, 254, 255, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(124, 242, 245, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(37, 198, 205, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(8, 143, 146, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(37, 198, 205, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(37, 198, 205, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(159, 132, 77, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(212, 254, 255, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(19, 167, 171, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(194, 157, 98, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(159, 132, 77, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(95, 74, 43, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(95, 74, 43, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(145, 113, 66, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(184, 148, 95, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(150, 116, 65, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(95, 74, 43, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(95, 74, 43, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(145, 113, 66, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(145, 113, 66, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(95, 74, 43, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(76, 61, 38, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(152, 120, 73, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(152, 120, 73, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(145, 113, 66, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(95, 74, 43, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(95, 74, 43, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(95, 74, 43, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(116, 90, 54, 255)" />
<rect x="13" y="13" width="1" height="1" fill="rgba(145, 113, 66, 255)" />
<rect x="14" y="13" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="1" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="13" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
<rect x="14" y="14" width="1" height="1" fill="rgba(54, 43, 27, 255)" />
</svg>);
export default MinecraftSoulCampfire;